import React from "react";
import Plot from "react-plotly.js";
 
interface PlotterProps {
  data: any[];
  layout: any;
  isLoading: boolean;
  compress?: boolean;
  shapes?: any[];
}

const Plotter = (props: PlotterProps) => {
  // Stable per-instance id so Plotly preserves this chart's zoom/pan
  // (uirevision) across re-renders, without coupling to other instances.
  const idRef = React.useRef(Math.random().toString(36).slice(2));

  const effectiveLayout = React.useMemo(() => {
    // Deep clone so nested objects (xaxis, yaxis, ...) are NOT shared with
    // the caller's layout or with any other Plotter instance. Plotly mutates
    // these in place on zoom/pan, which is what caused two charts to couple.
    const base = structuredClone(props.layout);
    base.uirevision = idRef.current;
    if (props.shapes) base.shapes = props.shapes;

    if (props.compress) {
      base.xaxis = {
        ...base.xaxis,
        rangebreaks: [
          { bounds: ["sat", "mon"] },
          { bounds: [16, 9.5], pattern: "hour" },
        ],
      };
    }

    return base;
  }, [props.compress, props.layout, props.shapes]);
 
  // react-plotly.js also mutates traces in place (it assigns uids, etc.),
  // so give this instance its own copy of the data as well.
  const plotData = React.useMemo(
    () => structuredClone(props.data),
    [props.data]
  );
 
  if (props.isLoading) {
    return <div className="text-gray-500">Loading...</div>;
  }
 
  if (props.data.length === 0) {
    return <p className="text-gray-500">Data array empty</p>;
  }
 
  return (
    <Plot
      data={plotData}
      layout={effectiveLayout}
      useResizeHandler={true}
      style={{ width: "100%" }}
    />
  );
};
 
export default Plotter;
